import React from 'react';
import { render } from 'react-dom';
import Router from 'router';
import 'antd/dist/antd.css';

render(<Router />, document.getElementById('root'));
